<div class="d-flex align-items-center justify-content-center" style="min-height: 600px;">
    <div class="card text-center border-0">
        <div class="card-body">
          <h5 class="card-title"> <p style="font-size: 4em"><i class="fa-solid fa-lock"></i></p>Access Denied</h5>
          <p class="card-text">You do not have permission to view this page.</p>      
        </div>
    </div>
</div>

